const $$splitComponentImporter = () => import('/app/frontend/src/routes/_app/user/billing/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_app/user/billing/')({
  staticData: {
    breadCrumb: 'Billing'
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});